import { useSelector, useDispatch } from 'react-redux';
import { useGetCartProductsQuery } from '../features/products/productsApiSlice';
import { selectCartItems, initiateCart } from '../features/users/userSlice';
import useAuth from './useAuth';

const useCart = () => {
  const dispatch = useDispatch();
  const { id } = useAuth();
  
  // Get cart items from Redux store
  const cartItems = useSelector(selectCartItems);
  
  // Fetch cart items if not in store
  const { 
    data: fetchedCartItems,
    isLoading,
    isError,
    error,
    isSuccess
  } = useGetCartProductsQuery(id, {
    skip: Array.isArray(cartItems) && cartItems.length > 0
  });

  // Load cart items into store if fetched successfully
  if (isSuccess && fetchedCartItems && (!Array.isArray(cartItems) || cartItems.length === 0)) {
    dispatch(initiateCart(fetchedCartItems));
  }

  return {
    cartItems: Array.isArray(cartItems) ? cartItems : (fetchedCartItems || []),
    isLoading,
    isError,
    error,
    isSuccess
  };
};

export default useCart; 